module.exports = __webpack_public_path__ + "static/burnished_hart-5c521e19b02e964efbf1b84ac3c5fafd.jpg";